import { render, staticRenderFns } from "./tool-setting.vue?vue&type=template&id=5bd51e2e&"
import script from "./tool-setting.vue?vue&type=script&lang=js&"
export * from "./tool-setting.vue?vue&type=script&lang=js&"
import style0 from "./tool-setting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports